module.exports = __webpack_public_path__ + "img/top-services-mobile.1eebe488.png";